import * as React from 'react';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Input, Alert, Select, InputNumber, Radio, Checkbox, Row } from 'antd';
import { connect } from 'react-redux';
import {
	plannedMaintenanceSchedulesRestCrudThunksForBuyer,
	plannedMaintenanceSchedulesRestCrudThunksForSupplier,
} from '../../thunks/planned_maintenance_schedules_thunks';
import { FormComponentProps } from '@ant-design/compatible/lib/form/Form';
import { withRouter } from 'react-router';
import {
	getCurrency,
	nullSafeGet,
	nullSafeGetOrElse,
	nullSafeToFixed,
} from '../../utils/DataAccessUtils';
import BackButton from '../back_button/BackButton';
import OWAsyncSelect from '../ow_async_select/OWAsyncSelect';
import {
	locationsRestCrudThunksForBuyer,
	locationsRestCrudThunksForSupplier,
} from '../../thunks/locations_thunks';
import {
	plannedMaintenanceTemplatesRestCrudThunksForBuyer,
	plannedMaintenanceTemplatesRestCrudThunksForSupplier,
} from '../../thunks/planned_maintenance_templates_thunks';
import {
	assetsRestReadThunk,
	assetsRestCrudThunksForBuyer,
	assetsRestCrudThunksForSupplier,
} from '../../thunks/assets_thunks';
import {
	assetTypesRestCrudThunksForBuyer,
	assetTypesRestCrudThunksForSupplier,
} from '../../thunks/asset_types_thunks';

import {
	fetchSupplierFacilitiesInPrivateNetworkForBuyer,
	fetchSupplierFacilitiesInPrivateNetworkForSupplier,
	supplierFacilitiesRestCrudThunksForBuyer,
	supplierFacilitiesRestCrudThunksForSupplier,
} from '../../thunks/supplier_facilities_thunks';
import { debounce } from '../../utils/PerformanceUtils';
import { getBuyerCompanyApprovalTiers } from '../../thunks/company_approval_thunks';
import { ROLE_TYPES } from '../../utils/DataConstants';
import { BUYER_ADMIN_ONLY } from '../roles/roles';
import _ from 'lodash';
import { DAYS_OF_THE_WEEK } from '../../constants/times';
import { Option } from 'antd/es/mentions';
import {
	breakdownFrequencyText,
	capitalize,
	getFrequencyUnit,
	getNumberSuffix,
	getWeekOfTheMonth,
	isLastDayOfTheMonth,
} from '../../utils/DataFormatterUtils';
import BuyerRegionsLocationsTreeSelect from '../regions_tree_select/RegionsLocationsTreeSelect';
import AssetNumberDisplay from '../asset_row_display/AssetNumberDisplay';
import FileUploader from '../file_uploader/FileUploader';
import OWDatePicker from '../ow_date_picker/OWDatePicker';
import ClearErrors from '../clear_errors/ClearErrors';
import { PLANNED_MAINTENANCE_SCHEDULES_CRUD_ACTION_CREATORS } from '../../actions/planned_maintenance_schedules_actions';
import OWRichTextEditor from '../../rich_text_editor/OWRichTextEditor';
import { getExchangeRate } from '../../thunks/currencies_thunks';
import { validatePlannedMaintenanceNTE } from '../planned_maintenance_utils/planned_maintenance_utils';
import OWButton from '../ow_button/OWButton';
import {
	PlannedMaintenanceTechnicianSelect,
	canAssignPlannedMaintenanceTechnician,
} from '../planned_maintenance_technician_select/PlannedMaintenanceTechnicianSelect';
import { UserNameWithEmail } from '../name_component/user/UserNameWithEmail';

const moment = require('moment');

require('./EditSpecificPlannedMaintenanceScheduleForm.less');
const PLANNED_MAINTENANCE_SCHEDULE_FORM_LOCATIONS_AUTOCOMPLETE =
	'PLANNED_MAINTENANCE_SCHEDULE_FORM_LOCATIONS_AUTOCOMPLETE';
const PLANNED_MAINTENANCE_SCHEDULE_FORM_ASSETS_AUTOCOMPLETE =
	'PLANNED_MAINTENANCE_SCHEDULE_FORM_ASSETS_AUTOCOMPLETE';
const PLANNED_MAINTENANCE_SCHEDULE_FORM_ASSET_TYPES_AUTOCOMPLETE =
	'PLANNED_MAINTENANCE_SCHEDULE_FORM_ASSET_TYPES_AUTOCOMPLETE';
const PLANNED_MAINTENANCE_SCHEDULE_FORM_PLANNED_MAINTENANCE_TEMPLATES_AUTOCOMPLETE =
	'PLANNED_MAINTENANCE_SCHEDULE_FORM_PLANNED_MAINTENANCE_TEMPLATES_AUTOCOMPLETE';
const PLANNED_MAINTENANCE_FORM_WORK_ORDER_PRIORITIES_AUTOCOMPLETE =
	'PLANNED_MAINTENANCE_FORM_WORK_ORDER_PRIORITIES_AUTOCOMPLETE';

const FORM_FIELD_WIDTH_STYLE = { maxWidth: 600 };

interface EditSpecificPlannedMaintenanceScheduleFormProps extends FormComponentProps {
	creating: boolean;
	updating: boolean;
	formData: any;
	history: any;
	redirectForwardUrl?: string;
	onSuccess?: any;
	plannedMaintenanceTemplates: any;
	fetchPlannedMaintenanceTemplates: any;
	fetchMultiplePlannedMaintenanceTemplates: any;
	fetchLocations: any;
	fetchAssets: any;
	fetchMultipleAssets: any;
	fetchAssetTypes: any;
	fetchMultipleAssetTypes: any;
	locations: any;
	assets: any;
	assetTypes: any;
	createErrors: any[];
	updateErrors: any[];
	currentUser: any;
	create: any;
	update: any;
	fetchMultipleSupplierFacilitiesInPrivateNetwork: any;
	fetchSupplierFacilitiesInPrivateNetwork: any;
	supplierFacilities: any;
	fetchApprovalHeirarchy: any;
	userType: string;
}

class EditSpecificPlannedMaintenanceScheduleForm extends React.Component<
	EditSpecificPlannedMaintenanceScheduleFormProps,
	any
> {
	constructor(props) {
		super(props);
		this.state = {
			nte: props.formData.nte,
			spendCategoryId: null,
			approvalHeirarchy: {},
			frequencyUnit: getFrequencyUnit(props.formData.frequency),
			editorRef: React.createRef(),
			currencyExchangeRateBuyerToLocation: 1,
			supplier: nullSafeGet('formData.routeToSupplier', props),
			nteStatus: undefined,
			nteMessage: undefined,
		};
	}

	checkBuyerToLocationCurrencyChange = (location) => {
		const { currentUser, fetchExchangeRate } = this.props;

		const locationCurrencyId = getCurrency({ location }).id;
		const buyerCurrencyId = getCurrency({ currentUser }).id;
		if (locationCurrencyId !== buyerCurrencyId) {
			fetchExchangeRate(locationCurrencyId, buyerCurrencyId, currentUser.contactType).then(
				(rate) => {
					this.setState({
						currencyExchangeRateBuyerToLocation: nullSafeGetOrElse('conversionRate', rate, 1),
					});
				}
			);
		} else {
			this.setState({ currencyExchangeRateBuyerToLocation: 1 });
		}
	};

	componentDidMount() {
		const { currentUser, fetchApprovalHeirarchy, formData, form } = this.props;
		const { supplier } = this.state;
		const basedOn = formData.basedOn;
		fetchApprovalHeirarchy().then((data) => {
			const tiers = nullSafeGet('0.tierDetails', data);
			if (tiers && tiers.length > 0) {
				const userTier =
					_.find(tiers, (item) => _.find(item.approvers, { email: currentUser.email })) || tiers[0];
				this.setState({
					approvalHeirarchy: { amount: userTier.amountUpto || 1000000000 },
				});
			}
		});
		this.checkBuyerToLocationCurrencyChange(formData.location);
		const isAssignedToInternalSupplier = nullSafeGet('status', supplier) === 'private';
		if (isAssignedToInternalSupplier) {
			form.setFieldsValue({ nte: undefined });
			this.setState({ nte: undefined });
		}
	}

	handleNTEValueChange = (e) => {
		const inputString = e.target.value;
		this.setState({ nte: inputString });
	};

	getAdditionalInfo = () =>
		nullSafeGet('state.editorRef.current', this) &&
		(this.state.editorRef.current as any).getContent();

	handleSubmit = (e, submitAction) => {
		const { history, redirectForwardUrl, onSuccess, formData } = this.props;
		e.preventDefault();
		this.props.form.validateFields((err, values) => {
			if (!err) {
				const monthConfig =
					values.frequencyUnit === 'months'
						? values.monthConfig !== 'undefined'
							? values.monthConfig
							: undefined
						: undefined;
				const weekDays =
					values.frequencyUnit === 'weeks'
						? values.weekDays.map((day) => _.lowerCase(day))
						: undefined;

				const pMScheduleCommonValues = {
					...formData,
					title: values.title,
					scheduleId: values.scheduleId,
					startDate: moment(values.startAndEndDates[0]).format(`YYYY-MM-DD`),
					endDate: values.startAndEndDates[1]
						? moment(values.startAndEndDates[1]).format(`YYYY-MM-DD`)
						: undefined,
					plannedMaintenanceTemplateId: values.plannedMaintenanceTemplateId,
					frequency: 'every' + values.frequency + values.frequencyUnit,
					weekDays,
					monthConfig,
					status: values.status,
					basedOn: values.basedOn,
					supplierFacilityId: values.supplierFacilityId,
					assignedTechnicianEmail: this.getAssignedTechnicianEmail(values),
					createConfig: values.createConfig,
					nte: values.nte ? parseFloat(values.nte) : undefined,
					supplierContractId: values.supplierContractId,
					supplierContractDocuments: values.supplierContractDocuments,
					additionalInfo: this.getAdditionalInfo(),
				};
				if (values.basedOn === 'asset') {
					const plannedMaintenanceSchedule = {
						...pMScheduleCommonValues,
						assetId: formData.assetId,
						id: formData.id,
					};
					submitAction(plannedMaintenanceSchedule).then((record) => {
						if (redirectForwardUrl) {
							history.push(redirectForwardUrl);
						}
						if (onSuccess) {
							onSuccess(record, 'asset');
						}
					});
				} else if (values.basedOn === 'location') {
					const plannedMaintenanceSchedule = {
						...pMScheduleCommonValues,
						locationId: formData.locationId,
						id: formData.id,
					};
					submitAction(plannedMaintenanceSchedule).then((record) => {
						if (redirectForwardUrl) {
							history.push(redirectForwardUrl);
						}
						if (onSuccess) {
							onSuccess(record, 'location');
						}
					});
				} else if (values.basedOn === 'assetType') {
					const plannedMaintenanceSchedule = {
						...pMScheduleCommonValues,
						assetTypeId: formData.assetTypeId,
						locationId: formData.locationId,
					};
					submitAction(plannedMaintenanceSchedule).then((record) => {
						if (redirectForwardUrl) {
							history.push(redirectForwardUrl);
						}
						if (onSuccess) {
							onSuccess(record, 'assetType');
						}
					});
				}
			}
		});
	};

	handleFileManualUpload = (supplierContractDocuments) => {
		const { form } = this.props;
		form.setFieldsValue({ supplierContractDocuments });
	};

	handleFileListChange = (info) => {
		if (info.file.status === undefined) {
			info.fileList.splice(-1, 1);
		}
		return info;
	};

	handleSupplierChange = (supplierFacilityId) => {
		const { form, supplierFacilities } = this.props;
		const supplier = nullSafeGet(`records.${supplierFacilityId}`, supplierFacilities);
		const isAssignedToInternalSupplier = nullSafeGet('status', supplier) === 'private';
		if (isAssignedToInternalSupplier) {
			form.setFieldsValue({ nte: undefined });
			this.setState({ nte: undefined });
		}
		if (form.getFieldValue('assignedTechnicianEmail')) {
			form.setFieldsValue({ assignedTechnicianEmail: undefined });
		}
		this.setState({ supplier });
	};

	canAssignTechnician = () =>
		canAssignPlannedMaintenanceTechnician(
			this.props.userType,
			this.props.form.getFieldValue('supplierFacilityId'),
			this.state.supplier
		);

	// A single update stores exactly what is sent, so leaving the field out clears the technician.
	// The buyer app can't edit it: keep the stored one unless the supplier it belongs to changed.
	getAssignedTechnicianEmail = (values) => {
		const { formData, userType } = this.props;
		if (userType === ROLE_TYPES.SUPPLIER) {
			return this.canAssignTechnician() ? values.assignedTechnicianEmail : undefined;
		}
		return values.supplierFacilityId === formData.supplierFacilityId
			? formData.assignedTechnicianEmail
			: undefined;
	};

	render() {
		const {
			updating,
			creating,
			form,
			create,
			createErrors,
			update,
			updateErrors,
			plannedMaintenanceTemplates,
			fetchPlannedMaintenanceTemplates,
			fetchMultiplePlannedMaintenanceTemplates,
			locations,
			assets,
			assetTypes,
			fetchAssets,
			fetchMultipleAssets,
			fetchAssetTypes,
			fetchMultipleAssetTypes,
			formData,
			currentUser,
			fetchMultipleSupplierFacilitiesInPrivateNetwork,
			fetchSupplierFacilitiesInPrivateNetwork,
			supplierFacilities,
			userType,
		} = this.props;
		const { getFieldDecorator, getFieldValue } = form;
		const {
			approvalHeirarchy,
			frequencyUnit,
			currencyExchangeRateBuyerToLocation,
			supplier,
			nteStatus,
			nteMessage,
		} = this.state;
		const buyerCurrency = getCurrency({ currentUser });
		const locationCurrency = getCurrency({ location: formData.location });
		const isUpdate = formData && formData.plannedMaintenanceTemplateId !== undefined;
		const submitAction = isUpdate ? update : create;
		const submitText = isUpdate ? 'Update schedule' : 'Create schedule';
		const isLoading = updating || creating;
		const DATE_FORMAT = 'MM-DD-YYYY';
		const isAdmin = currentUser.roles.some((role) => BUYER_ADMIN_ONLY.has(role));
		const basedOn = formData.basedOn;
		const frequencies = ['days', 'weeks', 'months', 'years'];
		const frequencyBreakdown = isUpdate
			? formData.frequency && breakdownFrequencyText(frequencyUnit)[formData.frequency]
			: { amount: 1 };
		const startAndEndDates = form.getFieldValue('startAndEndDates');
		const referenceDay =
			startAndEndDates && startAndEndDates[0] ? moment(startAndEndDates[0]) : moment();
		const dayOfTheWeek = DAYS_OF_THE_WEEK[referenceDay.day()];
		const weekOfTheMonth = getWeekOfTheMonth(referenceDay);

		const createConfig = nullSafeGet('createConfig', formData);
		const monthConfig = formData.monthConfig === undefined ? 'undefined' : formData.monthConfig;
		const convertedNTEValue = nullSafeToFixed(
			parseFloat(this.state.nte) * currencyExchangeRateBuyerToLocation
		);
		const hasDifferentNTEs =
			buyerCurrency && locationCurrency && buyerCurrency.id !== locationCurrency.id;

		const isAssignedToInternalSupplier = nullSafeGet('status', supplier) === 'private';

		getFieldDecorator('frequency', { initialValue: formData.frequency });
		getFieldDecorator('frequency', { initialValue: formData.frequency });
		getFieldDecorator('basedOn', { initialValue: formData.basedOn });
		if (basedOn === 'asset') {
			getFieldDecorator('asset', { initialValue: formData.asset });
			getFieldDecorator('assetId', { initialValue: formData.assetId });
		} else if (basedOn === 'location') {
			getFieldDecorator('location', { initialValue: formData.location });
			getFieldDecorator('locationId', { initialValue: formData.locationId });
		} else if (basedOn === 'assetType') {
			getFieldDecorator('assetType', { initialValue: formData.assetType });
			getFieldDecorator('assetTypeId', { initialValue: formData.assetTypeId });
		}
		getFieldDecorator('plannedMaintenanceTemplateId', {
			initialValue: formData.plannedMaintenanceTemplateId,
		});
		getFieldDecorator('status', { initialValue: formData.status || 'active' });
		//TODO: UPGRADE FORM
		return (
			<Form
				layout="vertical"
				onSubmit={(e) => this.handleSubmit(e, submitAction)}
				className="supplierForm"
				style={FORM_FIELD_WIDTH_STYLE}
			>
				<ClearErrors actionCreators={PLANNED_MAINTENANCE_SCHEDULES_CRUD_ACTION_CREATORS} />
				{createErrors.length > 0 ? (
					<Form.Item>
						<Alert message={createErrors.join(' ')} type="error" />
					</Form.Item>
				) : null}
				{updateErrors.length > 0 ? (
					<Form.Item>
						<Alert message={updateErrors.join(' ')} type="error" />
					</Form.Item>
				) : null}
				<Form.Item label="Name">
					{getFieldDecorator('title', {
						initialValue: formData.title,
						rules: [{ required: true, message: 'Please give the PM schedule a title.' }],
					})(<Input disabled={true} />)}
				</Form.Item>
				<Form.Item label="Schedule ID">
					{getFieldDecorator('scheduleId', {
						initialValue: formData.scheduleId,
					})(<Input />)}
				</Form.Item>
				<Form.Item label="Additional Info">
					{getFieldDecorator('additionalInfo', {
						initialValue: formData.additionalInfo,
					})(
						<OWRichTextEditor
							initialEditorState={formData.additionalInfo}
							editorRef={this.state.editorRef}
						/>
					)}
				</Form.Item>
				<Form.Item label="Scheduled Start and End Dates">
					{form.getFieldDecorator('startAndEndDates', {
						rules: [
							{
								type: 'array',
								required: true,
								message: 'Please select a start and end date!',
							},
						],
						initialValue: formData.startDate
							? [
									moment.parseZone(formData.startDate),
									formData.endDate ? moment.parseZone(formData.endDate) : undefined,
							  ]
							: [undefined, undefined],
					})(<OWDatePicker format={DATE_FORMAT} showTime={false} allowEmpty={[false, true]} />)}
				</Form.Item>
				{getFieldValue('basedOn') === 'meters' ? (
					<Form.Item label="Trigger">
						<div style={{ display: 'flex', alignItems: 'center' }}>
							<label style={{ marginRight: 8, whiteSpace: 'nowrap' }}>
								Create work order when reading
							</label>
							{getFieldDecorator('triggerOperator', {
								rules: [{ required: true, message: 'This field is required.' }],
							})(
								<Select style={{ marginRight: 8, width: 80 }}>
									<Select.Option value="=" key="=">
										=
									</Select.Option>
									<Select.Option value=">" key=">">
										{'>'}
									</Select.Option>
									<Select.Option value="<" key="<">
										{'<'}
									</Select.Option>
								</Select>
							)}
							{getFieldDecorator('triggerValue', {
								rules: [{ required: true, message: 'This field is required.' }],
							})(<Input style={{ width: 320 }} />)}
						</div>
					</Form.Item>
				) : (
					<Form.Item label="Frequency">
						<div>
							<label style={{ marginRight: 8 }}>Every</label>
							{getFieldDecorator('frequency', {
								initialValue: (frequencyBreakdown && frequencyBreakdown.amount) || 7,
								rules: [{ required: true, message: 'This field is required.' }],
							})(<InputNumber min={1} max={365} disabled={true} />)}
							{getFieldDecorator('frequencyUnit', {
								initialValue: frequencyUnit,
								rules: [{ required: true, message: 'This field is required.' }],
							})(
								<Select
									disabled={true}
									style={{ maxWidth: 100, marginLeft: 8 }}
									onChange={(frequencyUnit) => this.setState({ frequencyUnit })}
								>
									{frequencies.map((f) => (
										<Option key={f} value={f}>
											{f}
										</Option>
									))}
								</Select>
							)}
						</div>
					</Form.Item>
				)}
				{this.state.frequencyUnit === 'weeks' ? (
					<Form.Item label={'Repeat On'}>
						{getFieldDecorator('weekDays', {
							initialValue: formData.weekDays && formData.weekDays.map((d) => capitalize(d)),
							rules: [{ required: true, message: 'This field is required.' }],
						})(<Checkbox.Group options={DAYS_OF_THE_WEEK} disabled={true} />)}
					</Form.Item>
				) : this.state.frequencyUnit === 'months' ? (
					<Form.Item>
						{getFieldDecorator('monthConfig', {
							initialValue: monthConfig,
							rules: [{ required: true, message: 'This field is required.' }],
						})(
							<Select disabled={true}>
								<Option
									key={'monthConfig'}
									value={weekOfTheMonth.concat('_', _.lowerCase(dayOfTheWeek))}
								>
									On the {weekOfTheMonth} {dayOfTheWeek} of the month.
								</Option>
								{isLastDayOfTheMonth(referenceDay) ? (
									<Option key={'lastDayOfTheMonth'} value={'last_day'}>
										On the last day of the month.
									</Option>
								) : null}
								<Option key={'undefined'} value={'undefined'}>
									On the {referenceDay.date()}
									{getNumberSuffix(referenceDay.date())} day of the month.
								</Option>
							</Select>
						)}
					</Form.Item>
				) : null}
				<Form.Item label="Planned Maintenance Template">
					{getFieldDecorator('plannedMaintenanceTemplateId', {
						initialValue: formData.plannedMaintenanceTemplateId,
						rules: [{ required: true, message: 'This field is required.' }],
					})(
						<OWAsyncSelect
							disabled={true}
							stateSlice={plannedMaintenanceTemplates}
							targetCollectionName={
								PLANNED_MAINTENANCE_SCHEDULE_FORM_PLANNED_MAINTENANCE_TEMPLATES_AUTOCOMPLETE
							}
							fetchMultiple={(ids, targetCollectionName) => {
								fetchMultiplePlannedMaintenanceTemplates(ids, targetCollectionName);
							}}
							fetchData={(
								searchText,
								targetCollectionName,
								pagination,
								sorting,
								filters,
								addToTargetCollection
							) => {
								fetchPlannedMaintenanceTemplates(
									{ title: searchText },
									targetCollectionName,
									pagination,
									sorting,
									filters,
									addToTargetCollection
								);
							}}
							renderRecord={(plannedMaintenanceTemplate) => (
								<Select.Option
									key={plannedMaintenanceTemplate.id}
									value={plannedMaintenanceTemplate.id}
								>
									{plannedMaintenanceTemplate.title}
								</Select.Option>
							)}
							sortBy={{ sort_by: 'title', order: 'ascend' }}
						/>
					)}
				</Form.Item>
				<Form.Item>
					{getFieldDecorator('basedOn', {
						initialValue: formData.basedOn || 'location',
						rules: [{ required: true, message: 'This field is required.' }],
					})(
						<Radio.Group disabled={true}>
							<Radio value="asset">Based on Asset</Radio>
							<Radio value="location">Based on Location</Radio>
							<Radio value="assetType">Based on Asset Type</Radio>
						</Radio.Group>
					)}
				</Form.Item>

				{getFieldValue('basedOn') === 'location' ? (
					<Form.Item label="Location">
						{getFieldDecorator('locationId', {
							initialValue: formData.locationId,
							rules: [
								{
									required: getFieldValue('basedOn') === 'location',
									message: 'This field is required.',
								},
							],
						})(
							<BuyerRegionsLocationsTreeSelect
								mode="multiple"
								disabled={isUpdate || getFieldValue('basedOn') !== 'location'}
								emptyWhenDisabled={false}
								filtersSlice={locations}
								filtersValueAccessor={() => form.getFieldValue('locationIds')}
								targetCollectionName={PLANNED_MAINTENANCE_SCHEDULE_FORM_LOCATIONS_AUTOCOMPLETE}
								renderRecord={(d) => (
									<Select.Option value={d.id} key={d.id}>
										<div>{d.name}</div>
									</Select.Option>
								)}
								sortBy={{ sort_by: 'name', order: 'ascend' }}
							/>
						)}
					</Form.Item>
				) : null}
				{getFieldValue('basedOn') === 'asset' ? (
					<Form.Item label="Asset">
						{getFieldDecorator('assetId', {
							initialValue: formData.assetId,
							rules: [
								{
									required: getFieldValue('basedOn') === 'asset',
									message: 'This field is required.',
								},
							],
						})(
							<OWAsyncSelect
								mode="multiple"
								disabled={true}
								emptyWhenDisabled={false}
								stateSlice={assets}
								targetCollectionName={PLANNED_MAINTENANCE_SCHEDULE_FORM_ASSETS_AUTOCOMPLETE}
								fetchMultiple={(ids, targetCollectionName) => {
									fetchMultipleAssets(ids, targetCollectionName);
								}}
								fetchData={(
									searchText,
									targetCollectionName,
									pagination,
									sorting,
									filters,
									addToTargetCollection
								) => {
									fetchAssets(
										{ search: searchText },
										targetCollectionName,
										pagination,
										sorting,
										filters,
										addToTargetCollection
									);
								}}
								renderRecord={(d) => (
									<Select.Option value={d.id} key={d.id}>
										<div className="flex flex-col">
											<div>
												{nullSafeGetOrElse('location.name', d, '')} - {d.name}
												{!d.isActive && (
													<span
														style={{ marginLeft: 8, color: 'gray', fontWeight: 350, fontSize: 14 }}
													>
														(Inactive)
													</span>
												)}
											</div>
											<AssetNumberDisplay asset={d} />
										</div>
									</Select.Option>
								)}
								sortBy={{ sort_by: 'name', order: 'ascend' }}
							/>
						)}
					</Form.Item>
				) : null}
				{getFieldValue('basedOn') === 'assetType' ? (
					<div>
						<Form.Item label="Asset Type">
							{getFieldDecorator('assetTypeId', {
								initialValue: formData.assetTypeId,
								rules: [
									{
										required: getFieldValue('basedOn') === 'assetType',
										message: 'This field is required.',
									},
								],
							})(
								<OWAsyncSelect
									mode="multiple"
									disabled={true}
									emptyWhenDisabled={false}
									stateSlice={assetTypes}
									targetCollectionName={PLANNED_MAINTENANCE_SCHEDULE_FORM_ASSET_TYPES_AUTOCOMPLETE}
									fetchMultiple={(ids, targetCollectionName) => {
										fetchMultipleAssetTypes(ids, targetCollectionName);
									}}
									fetchData={(
										searchText,
										targetCollectionName,
										pagination,
										sorting,
										filters,
										addToTargetCollection
									) => {
										fetchAssetTypes(
											{ name: searchText },
											targetCollectionName,
											pagination,
											sorting,
											filters,
											addToTargetCollection
										);
									}}
									renderRecord={(d) => (
										<Select.Option value={d.id} key={d.id}>
											<div>{d.name}</div>
										</Select.Option>
									)}
									sortBy={{ sort_by: 'name', order: 'ascend' }}
								/>
							)}
						</Form.Item>
						<Form.Item label="Location">
							{getFieldDecorator('locationIds', {
								initialValue: formData.locationId,
								rules: [
									{
										required: getFieldValue('basedOn') === 'assetType',
										message: 'This field is required.',
									},
								],
							})(
								<BuyerRegionsLocationsTreeSelect
									mode="multiple"
									disabled={isUpdate || getFieldValue('basedOn') !== 'assetType'}
									emptyWhenDisabled={false}
									filtersSlice={locations}
									filtersValueAccessor={() => form.getFieldValue('locationIds')}
									targetCollectionName={PLANNED_MAINTENANCE_SCHEDULE_FORM_LOCATIONS_AUTOCOMPLETE}
									renderRecord={(d) => (
										<Select.Option value={d.id} key={d.id}>
											<div>{d.name}</div>
										</Select.Option>
									)}
									sortBy={{ sort_by: 'name', order: 'ascend' }}
								/>
							)}
						</Form.Item>
					</div>
				) : null}
				<Form.Item
					label="Assign To"
					help={
						'If left empty, rank 1 supplier will get picked based on problem type and location.'
					}
				>
					{getFieldDecorator('supplierFacilityId', {
						initialValue: formData.supplierFacilityId,
					})(
						<OWAsyncSelect
							placeholder="Rank 1 supplier will get picked based on problem type and location"
							allowClear={true}
							stateSlice={supplierFacilities}
							targetCollectionName={PLANNED_MAINTENANCE_FORM_WORK_ORDER_PRIORITIES_AUTOCOMPLETE}
							onChange={this.handleSupplierChange}
							fetchMultiple={(ids, targetCollectionName) => {
								fetchMultipleSupplierFacilitiesInPrivateNetwork(ids, targetCollectionName);
							}}
							fetchData={(
								searchText,
								targetCollectionName,
								pagination,
								sorting,
								filters,
								addToTargetCollection
							) => {
								fetchSupplierFacilitiesInPrivateNetwork(
									{ name: searchText, offset: 0, limit: 100 },
									targetCollectionName,
									pagination,
									sorting,
									filters,
									addToTargetCollection
								);
							}}
							renderRecord={(supplierFacility) => (
								<Select.Option key={supplierFacility.id} value={supplierFacility.id}>
									{supplierFacility.name}
								</Select.Option>
							)}
							additionalFilters={{
								problemTypeId: this.state.problemTypeId,
							}}
							sortBy={{ sort_by: 'name', order: 'ascend' }}
						/>
					)}
				</Form.Item>
				{this.canAssignTechnician() ? (
					<Form.Item
						label="Technician"
						help="Work orders from this schedule are assigned to this technician."
					>
						{getFieldDecorator('assignedTechnicianEmail', {
							initialValue:
								form.getFieldValue('supplierFacilityId') === formData.supplierFacilityId
									? formData.assignedTechnicianEmail
									: undefined,
						})(
							<PlannedMaintenanceTechnicianSelect
								key={form.getFieldValue('supplierFacilityId')}
								supplierFacilityId={form.getFieldValue('supplierFacilityId')}
							/>
						)}
					</Form.Item>
				) : null}
				{/* The buyer app can't list a supplier's techs, so it only shows the stored one. */}
				{userType !== ROLE_TYPES.SUPPLIER &&
				formData.assignedTechnicianEmail &&
				form.getFieldValue('supplierFacilityId') === formData.supplierFacilityId ? (
					<Form.Item
						label="Technician"
						help="Work orders from this schedule are assigned to this technician."
					>
						<UserNameWithEmail
							email={formData.assignedTechnicianEmail}
							mode="inline"
							fallback={formData.assignedTechnicianEmail}
						/>
					</Form.Item>
				) : null}
				<div className={'flex flex-row'}>
					<Form.Item
						label="Not To Exceed Amount"
						validateStatus={nteStatus}
						help={nteMessage}
						style={{ flex: 1 }}
					>
						{getFieldDecorator('nte', {
							initialValue: formData.nte || this.state.nte,
							validateTrigger: 'onChange',
							rules: [
								{
									validator: (rule, val, callback) =>
										validatePlannedMaintenanceNTE(
											rule,
											val,
											callback,
											formData,
											approvalHeirarchy,
											isAdmin,
											isAssignedToInternalSupplier,
											this.setState
										),
								},
							],
						})(
							<Input
								disabled={isAssignedToInternalSupplier}
								onChange={this.handleNTEValueChange}
								onClick={(e) => e.stopPropagation()}
								addonAfter={buyerCurrency.id}
								style={{ flex: 1 }}
							/>
						)}
					</Form.Item>
					{hasDifferentNTEs ? (
						<div className="flex flex-row" style={{ marginTop: 30, flex: 1 }}>
							<i
								className="icons8-font icons8-data-transfer"
								style={{ fontSize: 24, marginTop: 2, marginLeft: 20, marginRight: 20 }}
							/>
							<InputNumber
								style={{ height: 38, flex: 1 }}
								disabled={true}
								value={convertedNTEValue}
								addonAfter={locationCurrency.id}
							/>
						</div>
					) : null}
				</div>
				<Form.Item label={'Scheduling Configuration'}>
					{getFieldDecorator('createConfig', {
						initialValue: createConfig || 'create',
					})(
						<Select>
							<Option value={'create'}>Always schedule new work order.</Option>
							<Option value={'cancel_existing_and_create'}>
								Cancel existing and schedule a new work order.
							</Option>
							<Option value={'create_after_prior_completion'}>
								Wait until work order is completed.
							</Option>
							<Option value={'dont_create'}>Skip until work order is completed.</Option>
						</Select>
					)}
				</Form.Item>
				<Form.Item label="Contract ID">
					{getFieldDecorator('supplierContractId', {
						initialValue: formData.supplierContractId,
					})(<Input />)}
				</Form.Item>
				<Form.Item label="Contract Documents">
					{getFieldDecorator(`supplierContractDocuments`, {
						valuePropName: 'fileList',
						initialValue: formData.supplierContractDocuments,
					})(
						<FileUploader
							roleType={userType}
							defaultFileList={formData.supplierContractDocuments || []}
							convertedImages={nullSafeGet('convertedImages', formData)}
							handleUploadSuccess={this.handleFileManualUpload}
							handleFileListChange={this.handleFileListChange}
							accept="application/pdf"
							uploaderType={'dragger'}
						/>
					)}
				</Form.Item>
				<Form.Item>
					<OWButton
						type="primary"
						htmlType="submit"
						loading={isLoading}
						className="contactForm__button"
					>
						{submitText}
					</OWButton>
					<span style={{ marginLeft: '16px' }}>
						<BackButton buttonText="Cancel" />
					</span>
				</Form.Item>
			</Form>
		);
	}
}

const mapStateToProps = (state, ownProps) => ({
	history: ownProps.history,
	formData: ownProps.formData,
	redirectForwardUrl: ownProps.redirectForwardUrl,
	onSuccess: ownProps.onSuccess,

	locations: state.locations,
	assets: state.assets,
	assetTypes: state.asset_types,
	plannedMaintenanceTemplates: state.planned_maintenance_templates,
	createErrors: state.planned_maintenance_schedules.createErrors,
	updateErrors: state.planned_maintenance_schedules.updateErrors,
	creating: state.planned_maintenance_schedules.creating,
	updating: state.planned_maintenance_schedules.updating,
	currentUser: state.session.currentUser,
	supplierFacilities: state.supplier_facilities,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
	create: (entity) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? plannedMaintenanceSchedulesRestCrudThunksForSupplier.create(entity)
				: plannedMaintenanceSchedulesRestCrudThunksForBuyer.create(entity)
		),
	update: (entity) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? plannedMaintenanceSchedulesRestCrudThunksForSupplier.update(entity)
				: plannedMaintenanceSchedulesRestCrudThunksForBuyer.update(entity)
		),
	fetchMultipleAssets: (ids, targetCollectionName) =>
		dispatch(
			assetsRestReadThunk(ownProps.userType, { ids, noActiveFilter: true }, targetCollectionName)
		),
	fetchAssets: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			assetsRestReadThunk(
				ownProps.userType,
				{ ...params, noActiveFilter: true },
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		),
	fetchMultipleAssetTypes: (ids, targetCollectionName) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? assetTypesRestCrudThunksForSupplier.readMultiple(ids, targetCollectionName)
				: assetTypesRestCrudThunksForBuyer.readMultiple(ids, targetCollectionName)
		),
	fetchAssetTypes: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? assetTypesRestCrudThunksForSupplier.readLite(
						{ ...params, no_pagination: true },
						targetCollectionName,
						pagination,
						sorting,
						filters,
						addToTargetCollection
				  )
				: assetTypesRestCrudThunksForBuyer.readLite(
						{ ...params, no_pagination: true },
						targetCollectionName,
						pagination,
						sorting,
						filters,
						addToTargetCollection
				  )
		),
	fetchMultiplePlannedMaintenanceTemplates: (ids, targetCollectionName) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? plannedMaintenanceTemplatesRestCrudThunksForSupplier.readMultiple(
						ids,
						targetCollectionName
				  )
				: plannedMaintenanceTemplatesRestCrudThunksForBuyer.readMultiple(ids, targetCollectionName)
		),
	fetchPlannedMaintenanceTemplates: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? plannedMaintenanceTemplatesRestCrudThunksForSupplier.read(
						params,
						targetCollectionName,
						pagination,
						sorting,
						filters,
						addToTargetCollection
				  )
				: plannedMaintenanceTemplatesRestCrudThunksForBuyer.read(
						params,
						targetCollectionName,
						pagination,
						sorting,
						filters,
						addToTargetCollection
				  )
		),
	fetchSupplierFacilitiesInPrivateNetwork: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters
	) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? fetchSupplierFacilitiesInPrivateNetworkForSupplier(
						params,
						targetCollectionName,
						pagination,
						sorting,
						filters
				  )
				: fetchSupplierFacilitiesInPrivateNetworkForBuyer(
						params,
						targetCollectionName,
						pagination,
						sorting,
						filters
				  )
		),
	fetchMultipleSupplierFacilitiesInPrivateNetwork: (ids, targetCollectionName) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? supplierFacilitiesRestCrudThunksForSupplier.readMultiple(ids, targetCollectionName)
				: supplierFacilitiesRestCrudThunksForBuyer.readMultiple(ids, targetCollectionName)
		),
	fetchApprovalHeirarchy: (id) => dispatch(getBuyerCompanyApprovalTiers(ownProps.userType, null)()),
	fetchExchangeRate: (c1, c2, userType) => dispatch(getExchangeRate(c1, c2)(userType)),
});

const ComponentWithoutUserType = withRouter(
	connect(mapStateToProps, mapDispatchToProps)(EditSpecificPlannedMaintenanceScheduleForm)
);

export default connect(
	(state) => ({
		userType: (state as any).session.userType,
	}),
	() => ({})
)(Form.create()(ComponentWithoutUserType));
